import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/hearts.svg'


const _hoisted_1 = { class: "tellCityThankYou" }
const _hoisted_2 = { class: "mainTitle withArrow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-L icon" }, null, -1)
const _hoisted_4 = { class: "wp550" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "arrowBack",
        to: { name: 'FeedbackDashboard' }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createTextVNode(_toDisplayString(_ctx.$t("tell_city_view.thankyou")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('accessibility.feedback.heart'),
        class: "hearts"
      }, null, 8, _hoisted_5),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("feedback.feedback_thankyou_title")), 1),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("feedback.feedback_thankyou_description")), 1)
      ]),
      _createElementVNode("button", {
        class: "defaultButton smallButton",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'FeedbackDashboard' })))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("feedback.feedback_thankyou_button")) + " ", 1),
        _hoisted_6
      ])
    ])
  ]))
}